import convertToFields from '../util/convertToFields';
import getInitialValue from './getInitialValue';
/**
 * Converts an array of fields to a flat object of fields.
 * Key names match field ids, and initial values are determined by the `getInitialValue` function (@see {@link getInitialValue}).
 * Use for initial app state.
 * @param {Object} ion - An ION Instance
 * @param {Object} [overrides = {}] - any values that should override. (if data is passed into the app, these values will persist). Overrides object structure should match the ION being used.
 * @returns {Object} A flat object with only keys that take should take value.
 * @memberof module:ionHelpers
 */
const getIonValues = (flatIon, overrides) => {
    const ionValueReducer = (prev, current) => {
        const { id } = current;
        return ({ ...prev, [id]: getInitialValue(current) });
    };
    const valuesObj = flatIon.reduce(ionValueReducer, {});
    if (overrides) {
        if (typeof overrides !== 'object') {
            return valuesObj;
        }
        const fields = convertToFields(overrides);
        return { ...valuesObj, ...fields };
    }
    return valuesObj;
};
export default getIonValues;
